import { inject, Service } from '@angular/core';
import {EstimatedReleaseSchedule} from '../model/estimated-release-schedule';
import {Observable, Subject} from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {GoogleService} from './google-service';
import {environment} from '../../environments/environment';
import {Entity} from '../entity/entity';

@Service()
export class EstimatedReleaseScheduleService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl + 'estimatedReleaseSchedule/';

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  getEntityEstimatedSchedules(entityId: string): Observable<EstimatedReleaseSchedule[]> {
    const url = this.urlBase + entityId;
    return this.http.get<EstimatedReleaseSchedule[]>(url, {headers: this.getRequestHeaders()});
  }

  getEstimatedScheduleError(order: Entity): Observable<string> {
    const subject = new Subject<string>();
    this.getEntityEstimatedSchedules(order.id.entityId).subscribe({
      next: (schedules: EstimatedReleaseSchedule[]) => {
        if (!schedules || schedules.length === 0) {
          subject.next('Please complete the Estimated Release Schedule for this project');
        }
        const unitQuantity = order.unitQuantity;
        const scheduleQuantity = schedules.map(schedule => schedule.quantity)
          .reduce((accumulator, currentValue) => accumulator + currentValue);
        if (unitQuantity !== scheduleQuantity) {
          subject.next('The Estimated Release Schedule has a quantity of ' + scheduleQuantity + ' units,' +
            ' but this order has ' + unitQuantity + ' units. Please update the Estimated Release Schedule accordingly');
        } else {
          subject.next('');
        }
        subject.complete();
      }, error: (error) => {
        subject.error(error);
        subject.complete();
      }
    });
    return subject.asObservable();
  }

  saveSchedules(schedules: EstimatedReleaseSchedule[]): Observable<EstimatedReleaseSchedule[]> {
    const url = this.urlBase + 'save';
    const body = JSON.stringify(schedules);
    return this.http.post<EstimatedReleaseSchedule[]>(url, body, {headers: this.getPostHeaders()});
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set('Content-Type', 'application/json');
  }

}
